import type { Locale } from 'date-fns'
import { da, enGB, es, is, sv } from 'date-fns/locale'

export const DATE_FORMAT = 'dd.MM.yyyy'

const locales: Record<string, Locale> = {
	en: enGB,
	is,
	dk: da,
	se: sv,
	es
}

export const getDateLocale = (language: string) => locales[language] ?? enGB
